import React from 'react';
import { Helmet } from 'react-helmet-async';
import Hero from '../../components/Hero';
import CallToAction from '../../components/CallToAction';
import './ProjectPages.css';

import softwareHeroImage from '../../assets/images/software.jpg';

const EmbeddedSystems = () => {
  return (
    <div className="project-page embedded-systems">
      <Helmet>
        <title>IoT ve Gömülü Sistemler Çözümleri | ProgenX 2026</title>
        <meta name="description" content="ProgenX IoT ve gömülü sistem çözümleri. Sensör entegrasyonu, SCADA sistemleri, endüstriyel otomasyon, akıllı cihaz yazılımı ve gerçek zamanlı veri toplama platformları." />
        <meta name="keywords" content="IoT çözümleri, gömülü sistemler, sensör entegrasyonu, SCADA, endüstriyel otomasyon, akıllı cihaz, edge computing, nesnelerin interneti" />
        <meta property="og:title" content="IoT ve Gömülü Sistemler | ProgenX" />
        <meta property="og:description" content="IoT ve gömülü sistem çözümleriyle endüstriyel süreçlerinizi akıllı hale getirin." />
        <meta property="og:type" content="website" />
        <meta property="og:url" content="https://progenx.com.tr/projeler/gomulu-sistemler" />
        <link rel="canonical" href="https://progenx.com.tr/projeler/gomulu-sistemler" />
      </Helmet>

      <Hero 
        title="IoT ve Gömülü Sistemler" 
        backgroundImage={softwareHeroImage}
      />

      <div className="project-content">
        <div className="container">
          <section className="project-overview">
            <h2>Nesnelerin İnterneti ve Gömülü Sistem Çözümleri</h2>
            <p>
              ProgenX olarak, IoT (Nesnelerin İnterneti) ve gömülü sistem çözümleriyle cihazlarınızı 
              birbirine bağlıyor, endüstriyel süreçlerinizi akıllı hale getiriyoruz. Sensör 
              entegrasyonlarından SCADA sistemlerine, edge computing çözümlerinden bulut tabanlı 
              veri analiz platformlarına kadar geniş bir yelpazede hizmet sunuyoruz.
            </p>
          </section>

          <section className="features">
            <h2>IoT ve Gömülü Sistem Hizmetlerimiz</h2>
            <div className="features-grid">
              <div className="feature-item">
                <h3>Sensör ve Cihaz Entegrasyonu</h3>
                <p>
                  Farklı sensör ve IoT cihazlarını tek bir platform üzerinde yöneterek 
                  gerçek zamanlı veri toplama altyapıları kuruyoruz. MQTT, CoAP ve HTTP 
                  protokolleri ile güvenli iletişim sağlıyoruz.
                </p>
              </div>

              <div className="feature-item">
                <h3>SCADA ve Endüstriyel Otomasyon</h3>
                <p>
                  Üretim hatlarınız, enerji tesisleriniz ve su yönetim sistemleriniz için 
                  SCADA çözümleri geliştiriyoruz. Uzaktan izleme, alarm yönetimi ve 
                  otomasyon senaryoları ile operasyonel verimliliği artırıyoruz.
                </p>
              </div>

              <div className="feature-item">
                <h3>Edge Computing Çözümleri</h3>
                <p>
                  Veriyi kaynağında işleyerek gecikmeyi minimize eden edge computing 
                  uygulamaları geliştiriyoruz. Kritik kararların milisaniyeler içinde 
                  alınması gereken senaryolar için optimize edilmiş çözümler sunuyoruz.
                </p>
              </div>

              <div className="feature-item">
                <h3>Akıllı Raporlama ve Dashboard</h3>
                <p>
                  IoT verilerini anlamlı görselleştirmeler ve raporlarla sunuyoruz. 
                  Gerçek zamanlı dashboard'lar, trend analizleri ve anomali tespiti ile 
                  operasyonel kararlarınızı destekliyoruz.
                </p>
              </div>
            </div>
          </section>

          <section className="benefits">
            <h2>Neden ProgenX ile IoT Çözümleri?</h2>
            <div className="benefits-grid">
              <div className="benefit-item">
                <h3>Uçtan Uca Çözüm</h3>
                <p>Donanım seçiminden yazılım geliştirmeye, kurulumdan bakıma kadar 
                tüm süreçlerde yanınızdayız. Tek noktadan çözüm ile projenizi hızla hayata geçiriyoruz.</p>
              </div>

              <div className="benefit-item">
                <h3>Ölçeklenebilir Mimari</h3>
                <p>Binlerce cihazı yönetebilecek altyapılar kuruyoruz. Projeniz büyüdükçe 
                sistemimiz de büyüyor, yeni cihaz ve sensör eklemek kolay.</p>
              </div>

              <div className="benefit-item">
                <h3>Güvenlik Odaklı Tasarım</h3>
                <p>IoT cihazlarının güvenliğini en baştan tasarlıyoruz. Şifreli iletişim, 
                cihaz kimlik doğrulama ve güvenlik duvarları ile verilerinizi koruyoruz.</p>
              </div>

              <div className="benefit-item">
                <h3>Sektörel Deneyim</h3>
                <p>Eğitim, enerji, tarım ve üretim sektörlerinde IoT deneyimimiz var. 
                Sektörünüze özel gereksinimleri anlıyor ve buna uygun çözümler üretiyoruz.</p>
              </div>
            </div>
          </section>
        </div>
      </div>

      <CallToAction 
        title="IoT Projenizi Birlikte Hayata Geçirelim"
        subtitle="Akıllı cihaz ve sensör çözümleri için bize ulaşın."
        buttonText="İletişime Geçin"
        buttonLink="/iletisim"
      />
    </div>
  );
};

export default EmbeddedSystems;
